<div fxLayout="row" fxLayoutGap="10.5%">
    <div
        fxLayout="column"
        fxFlex="0 1 calc(25% - 0.5%)"
        fxFlex.lt-md="0 1 calc(50% - 0.5%)"
        fxFlex.lt-sm="100%"
        fxLayoutAlign="start start"
    >
        <h3>
            <strong>Estado:</strong> {{ factura?.pagada ? "Pagada" : "Impaga" }}
        </h3>
    </div>
    <div
        fxLayout="column"
        fxFlex="0 1 calc(25% - 0.5%)"
        fxFlex.lt-md="0 1 calc(50% - 0.5%)"
        fxFlex.lt-sm="100%"
        fxLayoutAlign="start start"
    >
        <h3><strong>Rut facturado:</strong> {{ factura.rutFacturado }}</h3>
    </div>
</div>

<div fxLayout="row" fxLayoutGap="10.5%">
    <div
        fxLayout="column"
        fxFlex="0 1 calc(25% - 0.5%)"
        fxFlex.lt-md="0 1 calc(50% - 0.5%)"
        fxFlex.lt-sm="100%"
        fxLayoutAlign="start start"
    >
        <h3><strong>Numero:</strong> {{ factura.numero }}</h3>
    </div>
    <div
        fxLayout="column"
        fxFlex="0 1 calc(25% - 0.5%)"
        fxFlex.lt-md="0 1 calc(50% - 0.5%)"
        fxFlex.lt-sm="100%"
        fxLayoutAlign="start start"
    >
        <h3>
            <strong>Fecha:</strong> {{ factura.fecha | date: "dd-MM-YYYY" }}
        </h3>
    </div>
</div>

<div fxLayout="row" fxLayoutGap="10.5%">
    <div
        fxLayout="column"
        fxFlex="0 1 calc(25% - 0.5%)"
        fxFlex.lt-md="0 1 calc(50% - 0.5%)"
        fxFlex.lt-sm="100%"
        fxLayoutGap="30.5%"
        fxLayoutAlign="start start"
    >
        <h3>
            <strong>Monto bruto:</strong>
            {{ factura.montoBrutoCLP | currency: "CLP":"symbol-narrow" }}
        </h3>
    </div>
    <div
        fxLayout="column"
        fxFlex="0 1 calc(25% - 0.5%)"
        fxFlex.lt-md="0 1 calc(50% - 0.5%)"
        fxFlex.lt-sm="100%"
        fxLayoutGap="30.5%"
        fxLayoutAlign="start start"
    >
        <h3>
            <strong>IVA:</strong>
            {{ factura.montoIVA | currency: "CLP":"symbol-narrow" }}
        </h3>
    </div>
</div>

<div *ngIf="esSupervisor" fxLayout="row" fxLayoutGap="10.5%">
    <div
        fxLayout="column"
        fxFlex="0 1 calc(25% - 0.5%)"
        fxFlex.lt-md="0 1 calc(50% - 0.5%)"
        fxFlex.lt-sm="100%"
        fxLayoutGap="30.5%"
        fxLayoutAlign="start start"
    >
        <h3>
            <strong>Pagada: </strong>
            <mat-slide-toggle
                *ngIf="_menuUsuarioSrvc.esSupervisor()"
                #checkActivacion
                (change)="toggleEstadoFactura(factura)"
            >
                {{ factura.pagada ? "Si" : "No" }}
            </mat-slide-toggle>
            <span *ngIf="!_menuUsuarioSrvc.esSupervisor()">{{
                factura.pagada ? "Si" : "No"
            }}</span>
        </h3>
    </div>
</div>
